function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.6 2.2C22.1582 1.86863 21.5314 1.95817 21.2 2.4L12.892 13.477L7.93898 8.52476L1.30834 16.3537C0.951404 16.7752 1.0037 17.4062 1.42514 17.7631L1.5259 17.8382C1.94204 18.1098 2.50504 18.0353 2.83452 17.6463L8.06 11.475L13.1082 16.5224L22.8 3.6C23.1314 3.15817 23.0418 2.53137 22.6 2.2ZM23 21C23 20.4477 22.5523 20 22 20H2.07143C1.51915 20 1.07143 20.4477 1.07143 21C1.07143 21.5523 1.51915 22 2.07143 22H22C22.5523 22 23 21.5523 23 21Z",
  fill: "#212121"
});

function SvgDaxGaicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxGaicon);
export default __webpack_public_path__ + "static/media/dax-gaicon.210efc26.svg";
export { ForwardRef as ReactComponent };